module.exports = __webpack_public_path__ + "media/fonts/Oricons-667edeec83c12ea669c0d89c12cf438f.svg";